declare global {
    interface Window {
        htmx: {
            ajax: (...args: unknown[]) => unknown
            find: (...args: unknown[]) => unknown
            process: (...args: unknown[]) => unknown
            values: (...args: unknown[]) => { [key: string]: unknown }
        }
    }
}

import { isDomReady } from 'utils/dom'
import { ComponentFactory } from 'services/component-factory'
import { ImageService } from 'services/image/image.service'

export class Main {
    /**
     * Once the DOM is ready, initialize the correct page type
     *
     * Each page type will load the components it needs.
     */
    public async init(): Promise<void> {
        await isDomReady()

        document.body.classList.add('js-enabled')

        new ComponentFactory('driving', 'brandPage')
        new ComponentFactory('driving', 'findCompare')
        new ComponentFactory('driving', 'modelCard')
        new ComponentFactory('driving', 'vehicleCard')
        new ComponentFactory('driving', 'modelPage')
        new ComponentFactory('driving', 'myPicks')
        new ComponentFactory('driving', 'vehicleFinder')
        new ComponentFactory('driving', 'vehicleDualComparisonPage')
        new ComponentFactory('driving', 'vehicleTrimComparisonPage')
        new ComponentFactory('driving', 'vehicleFinderForm')
        new ComponentFactory('driving', 'vehicleSortForm')
        new ComponentFactory('driving', 'comparisonResults')
        new ComponentFactory('driving', 'reviewsPage')
        new ComponentFactory('driving', 'reviewsHubPage')
        new ComponentFactory('driving', 'sellYourCar')
        new ComponentFactory('driving', 'inventoryListing')
        new ComponentFactory('driving', 'financingTool')
        new ComponentFactory('driving', 'shoppingTools')
        new ComponentFactory('driving', 'topVehiclesPage')
        new ComponentFactory('driving', 'topVehiclesOptionsPage')
        new ComponentFactory('header', 'menu')
        new ComponentFactory('header', 'menuDriving')
        new ComponentFactory('header', 'scroll')
        new ComponentFactory('header', 'search')
        new ComponentFactory('header', 'share')
        new ComponentFactory('header', 'searchMobile')
        new ComponentFactory('main', 'carousel')
        new ComponentFactory('main', 'characterCount')
        new ComponentFactory('main', 'copyLink')
        new ComponentFactory('main', 'dropdownChecklist')
        new ComponentFactory('main', 'focusInView')
        new ComponentFactory('main', 'formValidator')
        new ComponentFactory('main', 'gallery')
        new ComponentFactory('main', 'list')
        new ComponentFactory('main', 'memberContent')
        new ComponentFactory('main', 'modal')
        new ComponentFactory('main', 'myTopics')
        new ComponentFactory('main', 'myTopicsWidget')
        new ComponentFactory('main', 'popover')
        new ComponentFactory('main', 'readMore')
        new ComponentFactory('main', 'recaptcha')
        new ComponentFactory('main', 'recommendations')
        new ComponentFactory('main', 'savedArticles')
        new ComponentFactory('main', 'searchPage')
        new ComponentFactory('main', 'shareButton')
        new ComponentFactory('main', 'slider')
        new ComponentFactory('main', 'slidingDrawer', {
            threshold: 0,
            rootMargin: '300px'
        })
        new ComponentFactory('main', 'smoothHashScroll')
        new ComponentFactory('main', 'storyComment')
        new ComponentFactory('main', 'htmx')
        new ComponentFactory('main', 'ageGate')
        new ComponentFactory('video', 'leadVideo')
        new ComponentFactory('video', 'videoCentre')
        new ComponentFactory('video', 'playlist')
        new ComponentFactory('video', 'sticky')
        new ComponentFactory('video', 'singlePlayer')
        new ComponentFactory('video', 'jwPlayerVertical')
        new ComponentFactory('subscription', 'ccValidated')
        new ComponentFactory('subscription', 'eventPage')
        new ComponentFactory('subscription', 'auth')
        new ComponentFactory('widget', 'iframe')
        new ComponentFactory('widget', 'newsletter')
        new ComponentFactory('widget', 'priceline')
        new ComponentFactory('widget', 'sailthruPersonalizationEngine')
        new ComponentFactory('widget', 'skimlinks')
        new ComponentFactory('widget', 'trendingWidgetPositioner')
        new ComponentFactory('widget', 'weather')
        new ComponentFactory('main', 'savedArticlesPage')
        new ComponentFactory('main', 'myAccount')
        new ComponentFactory('main', 'featureBar')
        new ComponentFactory('main', 'conversationStarter')
        new ImageService()
    }
}
